export default __webpack_public_path__ + "static/media/bike_card_4.07caed99.png";